export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Название', value: 'product.name', sortable: false, align: 'left' },
          { text: 'Количество', value: 'quantity', sortable: false, align: 'left' },
          // { text: 'Серийный номер', value: 'barcode.code', sortable: false, align: 'right' },
          // { text: 'Цена', value: 'cost', sortable: false, align: 'right' },
          { text: 'Бонусы', value: 'bonuses', sortable: false, align: 'right' },
        ],
      },
      history: [],
      showHistoryID: false,
      editStatuses: ['redo'],
      showPhoto: false,
      currentPhoto: null,
      showPdf: false,
      currentPdf: null,
      isLoadPage: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    objectsList() { return this.$store.state.sales.objectsList || []; },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },
    showHistory(id) {
      const object = this.objectsList.filter(item => item.id === id);
      this.history = object.length ? object[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'adminReview': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        default: return '';
      }
    },
    handleFileClick(photo) {
      if (this.CheckDWG(photo)) {
        this.downloadFile(photo); // Скачиваем DWG файл
        return;
      }
      if (this.CheckPDF(photo)) {
        this.ShowPdf(photo);
      } else {
        this.ShowPhoto(photo);
      }
    },
    getFileIcon(photo) {
      if (this.CheckPDF(photo)) return 'pdf';
      if (this.CheckDWG(photo)) return 'dwg';
      return 'img';
    },
    getFileTitle(photo) {
      if (this.CheckDWG(photo)) {
        return `${photo.name} (Нажмите для скачивания)`;
      }
      return photo.name;
    },
    // Метод для скачивания файла
    downloadFile(photo) {
      if (photo.url) {
        // Сначала проверяем доступность файла
        fetch(photo.url, { method: 'HEAD' })
          .then((response) => {
            if (response.ok) {
              // Файл доступен - скачиваем
              const link = document.createElement('a');
              link.href = photo.url;
              link.download = photo.name || 'file.dwg';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              // Файл не доступен - показываем сообщение
              // eslint-disable-next-line
              alert('Файл недоступен для скачивания');
              console.error('File not found:', photo.url);
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            alert('Ошибка при загрузке файла');
            console.error('Download error:', error);
          });
      }
    },
    CheckDWG(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/dwg;') !== -1 || photo.base64.indexOf('/acad;') !== -1);
      }
      if (photo.url) {
        return (photo.url.toLowerCase().indexOf('.dwg') !== -1);
      }
      return false;
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
  },
  mounted() {
    this.$store.dispatch('sales/GetObjects', { profile_id: this.user.profile_id });
  },
};
